import React from 'react';
import NodeSymbolSelect from './NodeSymbolSelect';
import { Handle, Position } from 'reactflow';

const unitOptions = [
  { value: 'trading_days', label: 'Trading Days' },
  { value: 'bars', label: 'Bars' },
];

export default function PositionAgeNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #14b8a6',
      background: 'var(--card)',
      minWidth: 220,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#2dd4bf' }}>
        ⏱ Position Age
      </div>
      <NodeSymbolSelect value={data.symbol} onChange={(v) => onChange('symbol', v)} />

      <select
        value={data.unit || 'trading_days'}
        onChange={(e) => onChange('unit', e.target.value)}
        style={{ width: '100%', padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
      >
        {unitOptions.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>

      <div style={{ marginTop: 6, fontSize: 10, color: 'var(--muted)', lineHeight: 1.4 }}>
        Outputs elapsed position age for the current open trade.
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#14b8a6' }} />
    </div>
  );
}
